module.exports = __webpack_public_path__ + "static/img/Heart.b277f34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Heart.png
// module id = +Kx4
// module chunks = 1